import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import IconClose from "../../assets/IconClose.png";
import desktopImage from "../../assets/pickupexperience/desktop.png";
import mobileImage from "../../assets/pickupexperience/mobile.png";
import "./PickupExperienceModal.scss";

const PickupExperienceModal = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    // Verificar si la fecha actual es posterior al 9 de septiembre de 2025
    const currentDate = new Date();
    const endDate = new Date("2025-09-09"); // Martes 9 de septiembre de 2025

    // Si la fecha actual es posterior al 9 de septiembre, no mostrar el modal
    if (currentDate > endDate) {
      return;
    }

    // Mostrar el modal automáticamente después de 2 segundos
    const timer = setTimeout(() => {
      setShow(true);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  const handleClose = () => setShow(false);

  const handleReservar = () => {
    window.open(
      "https://oficial.montironi.com/pickupexperience/?utm_source=modal-landing&utm_medium=ford-experience",
      "_blank"
    );
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      size="lg"
      aria-labelledby="pickup-experience-modal"
      centered
      className="pickup-experience-modal"
    >
      <Modal.Body className="p-0">
        <div className="pickup-experience-content">
          {/* Botón cerrar */}
          <button className="pickup-close-btn" onClick={handleClose}>
            X
          </button>

          <div className="pickup-modal-body">
            {/* Imagen izquierda */}
            <div className="pickup-image-section">
              <img
                src={window.innerWidth > 768 ? desktopImage : mobileImage}
                alt="Ford Pick Up Experience 2025 Montironi"
                className="pickup-image"
              />
            </div>

            {/* Contenido derecho */}
            <div className="pickup-content-section text-md-start text-center">
              <div className="pickup-text-content">
                <h2 className="pickup-main-title">Vení a vivir la Pick Up Experience</h2>
                <p className="pickup-description">
                  Capacitación exclusiva y prueba de manejo junto a pilotos profesionales.
                </p>
                <div className="pickup-highlight">¡Cupos limitados!</div>
                <div className="w-100 text-start d-flex justify-content-md-start justify-content-center">
                  <button className="btn-blue btn btn-primary" onClick={handleReservar}>
                    Reservá tu lugar ahora
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default PickupExperienceModal;
